import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M16 4H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99h16c1.1 0 2-.9 2-2v-8l-6-6zM4 18.01V6h11v5h5v7.01H4z"
}), 'NoteOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/NoteOutlined.js
// module id = 5082
// module chunks = 2